import { getErrorMessage } from '@utils/error-message';
import { useContext, useRef } from 'react';
import {
  AbortableFetch,
  SnackbarContext,
  abortableFetch,
  useEventCallback,
} from '@eas/common-web';
import { ErrorObject } from '@models';
import { EvidenceApiUrl } from '@enums';

/**
 * Api call
 *
 * @param id
 */
function callApi() {
  return abortableFetch(`${EvidenceApiUrl.NOTIFICATION_RECEIVED}/read-all`, {
    method: 'POST',
  });
}

export function useReadAll({ refresh }: { refresh: () => void }) {
  /**
   * Fetch ref.
   */
  const fetch = useRef<AbortableFetch | null>(null);

  const { showSnackbar } = useContext(SnackbarContext);

  const handleReadAll = useEventCallback(async () => {
    try {
      if (fetch.current !== null) {
        fetch.current.abort();
      }

      fetch.current = callApi();

      await fetch.current.raw();

      refresh();
    } catch (e) {
      const err = e as ErrorObject<string>;

      const message = getErrorMessage(err);

      if (err.name !== 'AbortError') {
        showSnackbar(...message);
      }
    }
  });

  return { handleReadAll };
}
